var map = {
	"./axe.png": 2811,
	"./bg.png": 7398,
	"./bow.png": 4387,
	"./button.png": 6179,
	"./cotton_shirt.png": 8363,
	"./cotton_trousers.png": 4884,
	"./golden_sword.png": 2990,
	"./leather_hood.png": 7675,
	"./leather_pants.png": 9391,
	"./leather_tunic.png": 4208,
	"./linen_cowl.png": 7807,
	"./linen_pants.png": 56,
	"./linen_robe.png": 1674,
	"./linen_sandals.png": 1550,
	"./pickaxe.png": 5378,
	"./placeholder.png": 5760,
	"./sandals.png": 1331,
	"./shoes.png": 767,
	"./sickle.png": 2716,
	"./steel_armor.png": 8810,
	"./steel_boots.png": 8668,
	"./steel_helmet.png": 9648,
	"./steel_pants.png": 9621,
	"./sword.png": 8468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7916;